import type {Contact, ContactApi, ContactApiResponse, ContactsApiResponse} from "./contacts.types";

const composeName = (api: ContactApi): string => {
  const first = api.given_name ?? api.firstName ?? "";
  const last = api.family_name ?? api.lastName ?? "";
  const full = `${first} ${last}`.trim();
  return full || api.nickname || api.email || "Sin nombre";
};

export const adaptContact = (api: ContactApi): Contact => {
  const rawId = api.ID ?? api.id ?? api.contact_id ?? "";
  return {
    id: String(rawId),
    contactId: api.contact_id ?? String(rawId),
    email: api.email ?? "",
    fullName: composeName(api),
    nickname: api.nickname ?? "",
    phoneNumber: api.phoneNumber ?? api.phone_number ?? "",
  };
};

export const adaptContacts = (response: ContactsApiResponse): Contact[] => {
  const list = response?.data?.data;
  if (!Array.isArray(list)) return [];
  return list.map(adaptContact);
};

export const adaptSingleContact = (response: ContactApiResponse): Contact | null => {
  const payload = response?.data?.data;
  if (!payload) return null;
  return adaptContact(payload);
};
